import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface ISelectCard {
  checked?: boolean
}

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  background: ${(props: ISelectCard) => {
    if (props.checked) return `rgb(204, 204, 204)`
    return `${Theme.pallete.SECONDARY}`
  }};
  width: 144px;
  height: 113px;
  padding: 49px 19px 25px 19px;
  border-radius: 5px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  .sc-icon-content {
    display: flex;
    align-items: center;
  }

  .sc-icon {
    max-width: 19px;
    max-height: 19px;
    @media only screen and (min-width: 1441px) {
      max-width: 21px;
      max-height: 21px;
    }
  }

  .sc-title {
    color: ${Theme.pallete.PRIMARY};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    @media only screen and (min-width: 1441px) {
      font-size: 13px;
    }
  }

  .sc-selected-icon {
    display: flex;
    position: relative;
    bottom: 35px;
    left: 100px;
    max-width: 13.6px;
    max-height: 12.8px;
    @media only screen and (min-width: 1441px) {
      bottom: 40px;
      left: 115px;
      max-width: 16px;
      max-height: 15px;
    }
  }

  @media only screen and (min-width: 1441px) {
    width: 162px;
    height: 130px;
    padding: 56px 19px 29px 19px;
    border-radius: 5px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  }
`
